<template>
    <div class="row">
        <div class="col-md-6">
            <h5>GTD (KIT)</h5>
            <div class="alert alert-success my-3" role="alert">Подключено</div>
        </div>
        <div class="d-flex flex-column flex-grow col-md-6">
            <div class="row d-flex flex-row justify-content-end">
                <i v-on:click="isHelp = !isHelp" class="fas fa-question help-icon"></i>
            </div>
            <div v-if="isHelp" class="row sp-c">
                <p>
                    Работает без интеграционных ключей.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'GTD',
  data: function() {
    return {
      isHelp: true,
    }
  },
  created: function() {
    
  },
}
</script>
<style scope>

</style>
